import { isEqual } from "lodash";
import * as React from "react";

import {
  Loading,
  Markdown,
  Block,
  BlockItem,
  PageSubTitle,
} from "../../../shared/components";
import {
  ApplicantExamModel,
  ApplicantChallengeContextModel,
} from "../../../shared/models";
import NotFound from "../../common/error/notFound/NotFound";

export interface EditorReadmeProps {
  exam: ApplicantExamModel;
  challengeContext: ApplicantChallengeContextModel;
  challengeId: number;
  readme: { name: string; code: string } | undefined;
  getChallengeContext: (params: {}) => void;
  getPresigned: (payload: {}, params: {}) => void;
}

export interface EditorReadmeState {
  error: boolean;
}

class EditorReadme extends React.Component<
  EditorReadmeProps,
  EditorReadmeState
> {
  constructor(props: EditorReadmeProps) {
    super(props);

    this.state = {
      error: false,
    };
  }

  public UNSAFE_componentWillMount() {
    const { exam, challengeId, getChallengeContext } = this.props;

    if (exam.isChallengeStarted(challengeId)) {
      const challengeResult = exam.getResultByChallengeId(challengeId);
      getChallengeContext(challengeResult.id);
    }
  }

  public UNSAFE_componentWillReceiveProps(nextProps: EditorReadmeProps) {
    const { exam, challengeId, getChallengeContext, getPresigned } = nextProps;

    if (!isEqual(nextProps.exam, this.props.exam)) {
      if (exam.isChallengeStarted(challengeId)) {
        const challengeResult = exam.getResultByChallengeId(challengeId);
        getChallengeContext(challengeResult.id);
      } else {
        this.setState({
          error: true,
        });
      }
    } else if (
      !isEqual(nextProps.challengeContext, this.props.challengeContext) &&
      nextProps.challengeContext.challengeResultId
    ) {
      getPresigned(
        { files: ["README.md"] },
        exam.getResultByChallengeId(challengeId).id,
      );
    }
  }

  public render() {
    return this.state.error ? (
      <NotFound hasBackButton={false} />
    ) : (
      <div className="readme-container">
        <Block className="readme-header">
          <BlockItem className="readme-header__title">
            <PageSubTitle>{this.props.challengeContext.title}</PageSubTitle>
          </BlockItem>
        </Block>
        <Loading isOpen={!this.props.readme} />
        <Markdown
          className="readme-markdown"
          body={this.props.readme ? this.props.readme.code : ""}
          noRelativeLinks={true}
        />
      </div>
    );
  }
}

export default EditorReadme;
